module.exports = __webpack_public_path__ + "static/media/weddings-ceremony.bca563d9.jpg";